import { inject, Injectable } from "@angular/core";
import { POINT_REPOSITORY } from "@app/app.providers";
import { FindInTimeRangeInput } from "@arch/domain/repository";

@Injectable({
    providedIn: "root"
})
export class GetPointsRepositoryController {
    private readonly pointMapRepository = inject(POINT_REPOSITORY);
    public execute(input: FindInTimeRangeInput) {
        const points = this.pointMapRepository.findInTimeRange(input);
        return points;
    }
}
